import { type AnyActorRef } from "xstate"

import type { BaseFlowContext } from "@/lib/flows/base/types"

import type {
  CustomerApplications,
  CustomerFundingRequests,
} from "@boundless/bl-api-client/customer/models"

export const getNavigateParams = ({
  context,
}: {
  context: BaseFlowContext & {
    application?: CustomerApplications
    fundingNeeds?: CustomerFundingRequests
  }
}) => {
  const params: { applicationUuid?: string; fundingNeedsUuid?: string } = {}
  if (context.application?.uuid) {
    params.applicationUuid = context.application.uuid
  }
  if (context.fundingNeeds?.uuid) {
    params.fundingNeedsUuid = context.fundingNeeds.uuid
  }
  return params
}

export function navigateToPage({
  context,
  self,
}: {
  context: BaseFlowContext
  self: AnyActorRef
}) {
  // We use queueMicrotask here because, as per SCXML and XState spec,
  // at the time the entry action is executed, the state itself has
  // **not** yet been updated. As a result, in order to trigger the
  // navigation with the correct link options, we have to wait until
  // the next state comes around. We can either:
  //
  // 1. Use setTimeout(0)
  // 2. Use queueMicrotask
  //
  // The latter is regarded as a more modern
  // approach with some performance benefits.

  queueMicrotask(async () => {
    const snapshot = self.getSnapshot()
    const currentStateMeta = snapshot.machine.states[snapshot.value].meta
    const navigateOptions = currentStateMeta?.navigateOptions
    if (!navigateOptions) {
      console.warn(
        "No navigation options found for current state:",
        snapshot.value,
      )
      return
    }

    navigateOptions.params = {
      ...navigateOptions.params,
      ...getNavigateParams({ context }),
    }

    if (navigateOptions && context.navigate) {
      await context.navigate(navigateOptions)
    } else {
      console.warn("Failed to navigate to state page.")
    }
  })
}
